import { createFileRoute } from '@tanstack/react-router'
import { BookingSearchParams } from '~/features/appointments/schemas';
import { BookingPage } from '~/features/dashboard/pages/rescheduling/pages'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$program/reschedule-booking/',
)({
  component: () => (
    <section
        role="region"
        aria-label="Appointments"
        className="min-h-screen w-full"
    >
        <h1 className="text-2xl font-bold my-4 text-center">Reschedule appointment</h1>
        <BookingPage />
    </section>
),
validateSearch: (search: Record<string, unknown>): BookingSearchParams => {
    return {
        slot: search.slot as string | undefined,
        date: search.date as string | undefined,
    };
},
errorComponent: ({ error }: { error: Error }) => (
    <div
        role="alert"
        className="flex min-h-screen items-center justify-center p-4"
    >
        <div className="text-center">
            <h1 className="text-2xl font-bold">Error Loading Appointment booking</h1>
            <pre className="mt-4">{error.message}</pre>
        </div>
    </div>
),
})